export * from './input-money.component';
